$(function () {

    /**
     * SEO : OBFUSCATION LINKS
     */

    // Click.
    $('.obflink[data-o]').on('click', function (event) {
        var attribute = $(event.currentTarget).attr("data-o");
        if (event.ctrlKey) {
            var newWindow = window.open(decodeURIComponent(window.atob(attribute)), '_blank');
            newWindow.focus();
        } else {
            document.location.href = decodeURIComponent(window.atob(attribute));
        }
    });

    // Right click.
    $('.obflink[data-o]').on('contextmenu', function (event) {
        var attribute = $(event.currentTarget).attr("data-o");
        if (event.ctrlKey) {
            var newWindow = window.open(decodeURIComponent(window.atob(attribute)), '_blank');
            newWindow.focus();
        } else {
            window.open(decodeURIComponent(window.atob(attribute)), '_blank');
        }
    });

    /**
     * FIN - SEO : OBFUSCATION LINKS
     */

});

